import o from "react";
import { Facebook as r, Instagram as i, TwitterX as s, Youtube as e } from "@hagerty/icons";
import { HagertyLogo as g } from "../../logos/HagertyLogo";

var n = function n(_ref) {
  var a = _ref.wordmark,
      l = _ref.wordmarkUrl;
  return o.createElement("div", {
    className: "hg-global-footer__brand-footer"
  }, o.createElement("div", {
    className: "hg-global-footer__logo-social-links"
  }, o.createElement("div", {
    className: "hg-global-footer__logo"
  }, o.createElement("a", {
    href: "/",
    "aria-label": "Link to Hagerty homepage"
  }, o.createElement(g, null)), a && !l && o.createElement("div", {
    className: "hg-global-footer__wordmark"
  }, "| ", a), a && l && o.createElement("div", {
    className: "hg-global-footer__wordmark"
  }, o.createElement("a", {
    href: l
  }, "| ", a))), o.createElement("div", {
    className: "hg-global-footer__logo-tagline"
  }, "Protect, enjoy, and sell your classics."), o.createElement("div", {
    className: "hg-global-footer__social-icons"
  }, o.createElement("a", {
    className: "hg-global-footer__social-icon",
    href: "https://www.facebook.com/Hagerty",
    "aria-label": "Facebook link"
  }, o.createElement(r, null)), o.createElement("a", {
    className: "hg-global-footer__social-icon",
    href: "https://twitter.com/Hagerty",
    "aria-label": "TwitterX link"
  }, o.createElement(s, null)), o.createElement("a", {
    className: "hg-global-footer__social-icon",
    href: "https://instagram.com/hagerty",
    "aria-label": "Instagram link"
  }, o.createElement(i, null)), o.createElement("a", {
    className: "hg-global-footer__social-icon",
    href: "https://www.youtube.com/hagerty?sub_confirmation=1",
    "aria-label": "YouTube link"
  }, o.createElement(e, null)))));
};

export { n as BrandFooter };